exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-input-number-handler-wrap {\n  opacity: 1; }\n\n.contentRight .desc {\n  background-color: white; }\n\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 50px !important; }\n", ""]);

